import React from "react";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import BlogCard from "../components/BlogCard";
import Blogfront from "../components/Blogfront";
import "../components/BlogCategory.css"

const BlogsPage = () => {
  return (
    <div>
      <Nav bg="nav-bg-color" />
      <Blogfront />
      <div className="container">
        <div className="row">
          <div className="col-1 col-sm-3"></div>
          <div className="blog-category col-10 col-sm-6 d-flex justify-content-center">
            <div className="multi-button">
              <button>Azure</button>
              <button>Biztalk</button>
              <button>H I S</button>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-sm-6 col-md-4 mb-5">
            <BlogCard
              title="Managing BizTalk Server – Step by Step implementation of BizTalk360"
              desc="Performance is one of the main aspects to be considered in any software. In a most heavy traffic network involving servers with a..."
              author="Praveena"
              image="/images/azure.png"
            />
          </div>
          <div className="col-12 col-sm-6 col-md-4 mb-5">
            <BlogCard
              title="Automated Recovery Features of BizTalk360"
              desc="Last year, COVID-19 forced us to convert our INTEGRATE event from a live event to a remote event. Times are still unprecedented, so"
              author="Saravana"
              image="/images/basic-web-app.png"
            />
          </div>
          <div className="col-12 col-sm-6 col-md-4 mb-5">
            <BlogCard
              title="Understanding BizTalk performance counters through BizTalk360"
              desc="Performance is one of the main aspects to be considered in any software. In a most heavy traffic network involving servers with a..."
              author="Sandro"
              image="/images/GetStartedWithAzure.jpg"
            />
          </div>
          <div className="col-12 col-sm-6 col-md-4 mb-5">
            <BlogCard
              title="Understanding BizTalk performance counters through BizTalk360"
              desc="Performance is one of the main aspects to be considered in any software. In a most heavy traffic network involving servers with a..."
              author="Christini"
              image="/images/GetStartedWithAzure.jpg"
            />
          </div>
          <div className="col-12 col-sm-6 col-md-4 mb-5">
            <BlogCard
              title="Managing BizTalk Server – Step by Step implementation of BizTalk360"
              desc="Performance is one of the main aspects to be considered in any software. In a most heavy traffic network involving servers with a..."
              author="Praveena"
              image="/images/azure.png"
            />
          </div>
          <div className="col-12 col-sm-6 col-md-4 mb-5">
            <BlogCard
              title="Automated Recovery Features of BizTalk360"
              desc="Last year, COVID-19 forced us to convert our INTEGRATE event from a live event to a remote event. Times are still unprecedented, so"
              author="Saravana"
              image="/images/basic-web-app.png"
            />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default BlogsPage;
